import React from "react";

import authProvider from '../actions/authProvider';

export const AuthContext = React.createContext({authProvider});